/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import SearchBar from '../../components/search-bar'
import { CardFactoryShowRoom } from '../../components'
import ButtonStartVisitComponent from '../../components/button/start-visit'
import { ImagePlaceholderShowroom } from '../../assets'
import { Menu } from '../../components'

const TestingCards = ({ className = "" }) => {

  const overFlowStyle = {
    overflow: 'auto',
    height: '100%',
    maxHeight: 'calc(100vh - 90px)'
  }

  const Title = {
    color: '#112426',
    fontSize: '22px',
    textTransform: 'uppercase',
    fontFamily: 'Amorin Sans Serif',
    letterSpacing: '.5px',
    margin: '0',
    alignSelf: 'flex-end'
  }

  return (
    <div className={`background-dark p-0 relative vh-100 z-index-20 ${className}`} style={{width: '100%', maxWidth: '1920px'}}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-3 d-none d-md-block">
            <Menu showFactory={false} />
          </div>
          <div className="col-12 col-md-9" >
            <div className="row">
              <div className="col-12">
                <SearchBar />
              </div>
            </div>
            <div className="row mt-0 mt-md-4" style={{...overFlowStyle}}>
              <div className="col-12 col-md-6 col-xl-4 mt-0 mt-md-3 d-flex d-md-none justify-content-between justify-content-md-center pt-0 pt-md-3">
                <h1 className="d-md-none" style={{...Title}}>ShowRoom</h1>
                <ButtonStartVisitComponent />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom}
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork..."
                />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom}
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork" 
                />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom}
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork..."
                />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom} 
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork..."
                />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom}
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork..."
                />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom}
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork..."
                />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom} 
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork..."
                />
              </div>
              <div className="col-12 col-md-6 col-xl-4 mt-3">
                <CardFactoryShowRoom 
                  image={ImagePlaceholderShowroom}
                  title="Biombo inicial"
                  description="Amorim Cork Flooring is part of Corticeira Amorim, the largest world producer of cork..."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(TestingCards)
